import { LandfillFields } from '@common/enums';

export { LANDFILL_VIEW_MODE } from '@common/viewModes';

export const DEFAULT_LANDFILLS_SORT = {
    field: LandfillFields.createdAt,
    direction: -1,
};
